import { render, staticRenderFns } from "./sideMenuMobile.vue?vue&type=template&id=772a1efb"
import script from "./sideMenuMobile.vue?vue&type=script&lang=js"
export * from "./sideMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./sideMenuMobile.vue?vue&type=style&index=0&id=772a1efb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports